export const swapArr = (arr, p1, p2) => {
  const temp = arr[p1]
  arr[p1] = arr[p2]
  arr[p2] = temp
}

export default swapArr
